module.exports = __webpack_public_path__ + "static/media/logo_gol.56d50ba8.svg";